import { render } from "./Producto.vue?vue&type=template&id=88fdc8bc&scoped=true"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"

import "./Producto.vue?vue&type=style&index=0&id=88fdc8bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88fdc8bc"

export default script